module.exports = __webpack_public_path__ + "img/jifenrenwu_guanzhudianpuyouli.42512ad4.png";